import { LinkId } from '../../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../../common/components/SearchHeader/filters/useSearchFilters';
import {
  renderLocationChoice,
  LocationChoice,
} from '../../../../common/components/SearchHeader/types/LocationChoice';
import { DropDownFilterPill } from '../../FilterPill/DropDownFilterPill';
import { useOverlay } from '../../overlay/OverlayContext';
import { LocationFilterContent } from './LocationFilterContent/LocationFilterContent';

const TITLE = 'Location';

export const LocationFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const handleChange = (location: LocationChoice) => {
    setFilters({ ...filters, location, alwaysShowFilters: true });
    clear();
  };

  const handleClear = () => setFilters({ ...filters, location: undefined });
  return (
    <DropDownFilterPill
      hasValue={filters.location !== undefined}
      fixedMobileHeight
      onClear={handleClear}
      caption={filters.location ? renderLocationChoice(filters.location) : TITLE}
      trackingId={LinkId.FILTER_BY_LOCATION_BUTTON}
      content={<LocationFilterContent onChange={handleChange} value={filters.location} />}
    />
  );
};
